import { type Signal, signal } from '@preact/signals-react'

export class Campaign {
  id: Signal<string>
  discounted: Signal<number>
  original: Signal<number>

  constructor(id: string, discounted: number, original: number) {
    this.id = signal(id)
    this.discounted = signal(discounted)
    this.original = signal(original)
  }
}
